<template>
  <div class="taskManager">
    <!-- 任务管理器 -->
    <div class="list-table" v-show="isCardtable">
      <div class="top-title">服务器指标监控</div>
      <div class="mytable">
        <el-table
          :data="tableData"
          ref="tables1"
          id="tables1"
          stripe
          style="width: 100%;margin-bottom:20px"
          border
        >
          <el-table-column
            type="index"
            align="center"
            label="序号"
            width="60"
          ></el-table-column>
          <el-table-column
            prop="a"
            label="服务器IP"
            align="center"
            width="350"
          ></el-table-column>
          <el-table-column label="CPU" align="center">
            <template #default="{row}">
              <div class="mysort">{{ row.b }}</div>
            </template>
          </el-table-column>
          <el-table-column label="内存" align="center">
            <template #default="{row}">
              <div class="mysort">{{ row.c }}</div>
            </template>
          </el-table-column>
          <el-table-column label="硬盘" align="center">
            <template #default="{row}">
              <div class="mysort">{{ row.d }}</div>
            </template>
          </el-table-column>
          <el-table-column label="发送速率" align="center">
            <template #default="{row}">
              <div class="mysort">{{ row.e }}</div>
            </template>
          </el-table-column>
          <el-table-column label="接收速率" align="center">
            <template #default="{row}">
              <div class="mysort">{{ row.f }}</div>
            </template>
          </el-table-column>
          <el-table-column label="负载" align="center">
            <template #default="{row}">
              <div class="mysort">{{ row.g }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template #default="{row}">
              <div class="mysort" @click="openDetails(row)">详情</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- v-show="!isCardtable" -->
    <div class="card-data">
      <div class="card-title">
        <el-button
          type="primary"
          class="last-el-button"
          @click="isCardtable = true"
          >返回</el-button
        >
        <div class="details-title">
          服务器IP：{{ nowRowData.identification }}
        </div>
      </div>
      <div class="three-card">
        <div class="card-item">
          <div class="item-title">CPU</div>
          <div class="mycahr">
            <!-- <div id="mychart1" style="width:100%;height:100%"></div> -->
            <div id="mychart1" class="mychart1">
              <div class="neibox">{{ nowDetails.usageVO.cpu.cpuUsage }}</div>
            </div>
          </div>
          <div class="con-tip">
            <div class="tip-item">
              <p>CPU利用率</p>
              <p class="p22">{{ nowDetails.usageVO.cpu.cpuUsage }}</p>
            </div>
            <div class="tip-item">
              <p>CPU温度统计</p>
              <p class="p22">{{ nowDetails.usageVO.cpu.cpuTemperature }}</p>
            </div>
            <div class="tip-item">
              <p>空闲时间</p>
              <p class="p22">{{ nowDetails.usageVO.cpu.cpuLeisure }}</p>
            </div>
          </div>
          <div class="con-tip">
            <div class="tip-item">
              <p>用户态占用时长</p>
              <p class="p22">{{ nowDetails.usageVO.cpu.cpuUser }}</p>
            </div>
            <div class="tip-item">
              <p>系统态占用时长</p>
              <p class="p22">{{ nowDetails.usageVO.cpu.cpuSystem }}</p>
            </div>
            <div class="tip-item">
              <p>IO等待占用时长</p>
              <p class="p22">{{ nowDetails.usageVO.cpu.cpuIo }}</p>
            </div>
          </div>
        </div>
        <div class="card-item" style="margin:0px 12px">
          <div class="item-title">系统内存</div>
          <div class="mycahr">
            <!-- <div id="mychart1" style="width:100%;height:100%"></div> -->
            <div id="mychart1" class="mychart1">
              <div class="neibox">
                {{ nowDetails.usageVO.memory.memoryUsage }}
              </div>
            </div>
          </div>
          <div class="con-tip">
            <div class="tip-item">
              <p>总内存</p>
              <p class="p22">{{ nowDetails.usageVO.memory.memoryTotal }}</p>
            </div>
            <div class="tip-item">
              <p>已使用内存</p>
              <p class="p22">{{ nowDetails.usageVO.memory.memoryAvailable }}</p>
            </div>
            <div class="tip-item">
              <p>内存利用率</p>
              <p class="p22">{{ nowDetails.usageVO.memory.memoryUsage }}</p>
            </div>
          </div>
          <div class="con-tip">
            <div class="tip-item">
              <p>总缓冲区</p>
              <p class="p22">{{ nowDetails.usageVO.memory.memoryBuffer }}</p>
            </div>
            <div class="tip-item">
              <p>已使用缓存内存</p>
              <p class="p22">
                {{ nowDetails.usageVO.memory.memoryBufferUsage }}
              </p>
            </div>
            <div class="tip-item">
              <p>交换分区</p>
              <p class="p22">{{ nowDetails.usageVO.memory.memoryExchange }}</p>
            </div>
          </div>
        </div>
        <div class="card-item">
          <div class="item-title">系统硬盘</div>
          <div class="mycahr">
            <!-- <div id="mychart1" style="width:100%;height:100%"></div> -->
            <div id="mychart1" class="mychart1">
              <div class="neibox">
                {{ nowDetails.usageVO.disk.diskUsagePercent }}
              </div>
            </div>
          </div>
          <div class="con-tip">
            <div class="tip-item">
              <p>硬盘空间</p>
              <p class="p22">{{ nowDetails.usageVO.disk.diskTotal }}</p>
            </div>
            <div class="tip-item">
              <p>已使用硬盘空间</p>
              <p class="p22">{{ nowDetails.usageVO.disk.diskUsed }}</p>
            </div>
            <div class="tip-item">
              <p>可用硬盘空间</p>
              <p class="p22">{{ nowDetails.usageVO.disk.diskUsage }}</p>
            </div>
          </div>
          <div class="con-tip">
            <div class="tip-item">
              <p>硬盘利用率</p>
              <p class="p22">{{ nowDetails.usageVO.disk.diskUsagePercent }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="three-card" style="margin-top:15px">
        <div class="card-item">
          <div class="item-title">网络统计</div>
          <div class="mycahr">
            <!-- <div id="mychart1" style="width:100%;height:100%"></div> -->
            <div id="mychart1" class="mychart1">
              <div class="neibox">
                {{ nowDetails.usageVO.network.sendingRate }}
              </div>
            </div>
          </div>
          <div class="con-tip">
            <div class="tip-item">
              <p>发送速率</p>
              <p class="p22">{{ nowDetails.usageVO.network.sendingRate }}</p>
            </div>
            <div class="tip-item">
              <p>接收速率</p>
              <p class="p22">{{ nowDetails.usageVO.network.receivingRate }}</p>
            </div>
            <div class="tip-item">
              <p>发送包数</p>
              <p class="p22">{{ nowDetails.usageVO.network.sendingPackets }}</p>
            </div>
          </div>
          <div class="con-tip">
            <div class="tip-item">
              <p>接收包数</p>
              <p class="p22">
                {{ nowDetails.usageVO.network.receivingPackets }}
              </p>
            </div>
          </div>
        </div>
        <div class="card-item" style="margin:0px 12px">
          <div class="item-title">系统负载</div>
          <div class="mycahr">
            <!-- <div id="mychart1" style="width:100%;height:100%"></div> -->
            <div id="mychart1" class="mychart1">
              <div class="neibox">{{ nowDetails.usageVO.load.oneMinute }}</div>
            </div>
          </div>
          <div class="con-tip">
            <div class="tip-item">
              <p>1分钟</p>
              <p class="p22">{{ nowDetails.usageVO.load.oneMinute }}</p>
            </div>
            <div class="tip-item">
              <p>5分钟</p>
              <p class="p22">{{ nowDetails.usageVO.load.fiveMinute }}</p>
            </div>
            <div class="tip-item">
              <p>10分钟</p>
              <p class="p22">{{ nowDetails.usageVO.load.fifMinute }}</p>
            </div>
          </div>
        </div>
        <div
          class="card-item"
          style="border:0px;box-shadow: 0px 4px 8px 0px #fff;"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewAllByIp, getComputerUsageByIp } from "../api/application";
var mychar1;

export default {
  data() {
    return {
      tableData: [
        {
          a: "http://192.168.124.13:8080",
          b: 2,
          c: 2,
          d: 2,
          e: 2,
          f: 2,
          g: 2,
          h: 2,
          i: 2,
          j: 2,
        },
      ],
      isCardtable: true,
      option: {
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%",
        },
        series: [
          {
            name: "Pressure",
            type: "gauge",
            detail: {
              formatter: "{value}%",
            },
            data: [
              {
                value: 52,
                name: "SCORE",
              },
            ],
          },
        ],
      },
      nowRowData: { identification: "" },
      nowDetails: {
        identification: "192.168.124.166",
        usageVO: {
          cpu: {
            id: "1",
            identification: "192.168.124.166",
            createTime: null,
            cpuUsage: "1",
            cpuLeisure: "1",
            cpuUser: "1",
            cpuSystem: "1",
            cpuIo: "1",
            cpuTemperature: "1",
          },
          disk: {
            id: "1",
            identification: "192.168.124.166",
            createTime: null,
            diskTotal: "1",
            diskUsed: "1",
            diskUsage: "1",
            diskUsagePercent: "1",
          },
          load: {
            id: "1",
            identification: "192.168.124.166",
            createTime: null,
            oneMinute: "1",
            fiveMinute: "1",
            fifMinute: "1",
          },
          memory: {
            id: "1",
            identification: "192.168.124.166",
            createTime: null,
            memoryUsage: "1",
            memoryTotal: "1",
            memoryAvailable: "1",
            memoryBuffer: "1",
            memoryBufferUsage: "1",
            memoryExchange: "1",
          },
          network: {
            id: "1",
            identification: "192.168.124.166",
            createTime: null,
            sendingRate: "1",
            receivingRate: "1",
            sendingPackets: "1",
            receivingPackets: "1",
          },
        },
      },
      timerAll: null,
    };
  },

  mounted() {
    this.getAllList();
    //初始化图表
    //  this.init()
    var thats = this;
    this.timerAll = setInterval(() => {
      thats.dingshi();
    }, 5000);
  },
  beforeDestroy() {
    // 在页面销毁前清除定时器
    if (this.timerAll) {
      clearInterval(this.timerAll);
    }
  },

  methods: {
    //列表数据
    getAllList() {
      getNewAllByIp().then((res) => {
        if (res.code == 200) {
          this.tableData = res.data;
        } else {
          this.$message({ message: `获取失败`, type: "warning" });
        }
      });
    },
    //打开详情
    openDetails(data) {
      this.nowRowData = data;
      this.nowDetails = data;
      this.isCardtable = true;
    },
    // 定时任务
    dingshi() {
      if (this.isCardtable) {
        getNewAllByIp().then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        });
      } else {
        getComputerUsageByIp({ ip: this.nowRowData.identification }).then(
          (res) => {
            if (res.code == 200) {
              this.nowDetails = res.data;
            }
          }
        );
      }
    },
    //初始化图表
    init() {
      // mychar1 = echarts.init(document.getElementById("mychart1"));
      // mychar1.setOption(this.option,true);
    },
  },
};
</script>

<style lang="scss" scoped>
.taskManager {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .list-table {
    width: 100%;
    height: 100%;
    margin-bottom: 100px;
  }

  .top-title {
    width: 100%;
    font-size: 30px;
    text-align: center;
    margin-bottom: 10px;
  }

  .mytable {
    width: 100%;
    height: calc(100% - 50px);
  }

  .card-data {
    width: 100%;
    height: 100%;

    .card-title {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 15px;

      .details-title {
        font-size: 18px;
        margin-left: 20px;
      }
    }

    .three-card {
      width: 100%;
      height: calc(50% - 35px);
      display: flex;

      .card-item {
        height: 100%;
        flex: 1;
        /* 平分大 div 的宽度 */
        border: 1px solid #e7e3e3;
        /* 为了方便查看效果，添加边框 */
        border-radius: 10px;
        box-sizing: border-box;
        /* 让边框计算在内部 */
        box-shadow: 0px 4px 8px 0px #e8eff5;
        overflow: hidden;

        .item-title {
          width: 100%;
          height: 40px;
          background-color: #368ed9;
          color: #fff;
          display: flex;
          align-items: center;
          font-size: 16px;
          padding-left: 10px;
          box-sizing: border-box;
        }

        .mycahr {
          width: 100%;
          height: calc(100% - 150px);
          display: flex;
          align-items: center;
          justify-content: center;

          .mychart1 {
            width: 200px;
            height: 200px;
            //   background-color: red;
            border-radius: 50%;
            border: 18px solid #7d7dff;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;

            .neibox {
              width: 100px;
              height: 100px;
              border-radius: 50%;
              background-color: #fff;
              box-shadow: 0px 4px 8px 5px #e8eff5;
              color: #0032be;
              text-align: center;
              line-height: 100px;
              font-size: 30px;
              font-weight: 700;
            }
          }
        }
      }

      .con-tip {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 10px;
        box-sizing: border-box;

        p {
          font-size: 16px;
        }

        .p22 {
          font-size: 22px;
          margin-top: 5px;
        }

        .tip-item {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
